// Generated by ReScript, PLEASE EDIT WITH CARE


function getVM(onDemandVehicles, restricted_vehicle_ids) {
  return onDemandVehicles.filter(function (e) {
                var match = restricted_vehicle_ids.find(function (id) {
                      return e.id === id;
                    });
                return match !== undefined;
              }).map(function (vehicle) {
              return {
                      vehicle_id: vehicle.id,
                      vehicle_name: vehicle.display_name,
                      vehicle_imgs: vehicle.icons,
                      details: vehicle.details
                    };
            });
}

export {
  getVM ,
  
}
/* No side effect */
